var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"si-center-map",attrs:{"id":"situation-center-map"}},[_c('sc-map-popup',{attrs:{"settings":_vm.popupSettings}}),(_vm.isMatrixLegendActive)?_c('sc-map-legend'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }